module.exports = __webpack_public_path__ + "media/images/lp_cv-block-3-ab19577d103edd21604b2d0e8bb231c9.webp";